import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../components/AuthContext';

const Logout = () => {
  const { logout } = useContext(AuthContext);
  
  useEffect(() => {
    // Logout immediately when component mounts
    logout();
  }, [logout]);

  return (
    <div>Logging out...</div>
  );
};

export default Logout;
